export default __webpack_public_path__ + "static/miradouro-lisboa-6fdab7edaa64d82988ae9f332265eaa0.jpg";